import { IAsyncState } from 'apps/dialect/src/app/core/interfaces/async-state.interface';
import { AssertNotNullPipe } from 'apps/dialect/src/app/core/pipes/assert-not-null.pipe';
import { BehaviorSubject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { CommonsModule } from '@peca/commons';
import { DesignSystemModule, ModalComponent, Pagination, PaginationInitialState, PaginationInitialStateV2 } from '@peca/design-system';

import { IMonitoringRequest } from '../../interfaces/monitoring-request.interface';
import { IMonitoringResponse, IMonitoringResponseItem, IMonitoringResponseItemProduct } from '../../interfaces/monitoring-response.interface';
import { MonitoringService } from '../../services/monitoring.service';
import { MonitoringSearchComponent } from './monitoring-search/monitoring-search.component';

@Component({
  templateUrl: './monitoring.component.html',
  styleUrl: './monitoring.component.scss',
  imports: [CommonModule, CommonsModule, DesignSystemModule, AssertNotNullPipe, MonitoringSearchComponent],
})
export class MonitoringComponent {
  @ViewChild('products')
  productsModal!: ModalComponent;

  @ViewChild('logs')
  logsModal!: ModalComponent;

  searches$ = new BehaviorSubject<IAsyncState<IMonitoringResponse>>({});

  monitoringService = inject(MonitoringService);

  selectedProduct: IMonitoringResponseItemProduct | null = null;

  selectedLogs: IMonitoringResponseItem | null = null;

  pagination$ = new BehaviorSubject<Pagination>(PaginationInitialState);

  lastQuery: IMonitoringRequest | null = null;

  fetchSearches(query: IMonitoringRequest) {
    this.lastQuery = query;
    this.searches$.next({ loading: true });
    this.monitoringService.fetchMonitoring(query).subscribe({
      next: (data) => {
        this.pagination$.next({
          items: data.totalItems,
          total: data.totalPages,
          size: data.pageSize,
          page: data.currentPage + 1,
        });
        this.searches$.next({ data });
      },
    });
  }

  hasItems<T>(objectList?: Array<T>) {
    return objectList && objectList.length > 0;
  }

  firstOrNull<T>(objectList?: Array<T>) {
    if (!objectList || !objectList.length) {
      return null;
    }

    return objectList[0];
  }

  onSearch(event: IMonitoringRequest) {
    this.fetchSearches(event);
  }

  onClickOpenProductsModal(product: IMonitoringResponseItemProduct | null) {
    this.selectedProduct = product;
    this.productsModal.open();
  }

  onClickCloseProductsModal() {
    this.productsModal.close();
    this.selectedProduct = null;
  }

  onClickOpenLogsModal(logs: IMonitoringResponseItem | null) {
    this.selectedLogs = logs;
    this.logsModal.open();
  }

  onClickCloseLogsModal() {
    this.logsModal.close();
    this.selectedLogs = null;
  }

  onPageChange(pagination: Pagination): void {
    if (!this.lastQuery) return;

    const page = pagination.page ? pagination.page - 1 : 0;
    const query = { ...pagination, page: page };
    const { endDate, startDate, clientId, withResult } = this.lastQuery;

    this.fetchSearches({ ...query, endDate, startDate, clientId, withResult });
  }
}
